const state = {
  zoom: 2.41,
  visibility: {
    railroads: true,
    oilpipelines: true,
    gaspipelines: true,
    ports: true,
  },
};

const mutations = {
  setZoom(state, zoom) {
    if (zoom === 'in') {
      if (state.zoom < 6.41) {
        state.zoom++;
      }
    } else {
      if (state.zoom > 2.41) {
        state.zoom--;
      }
    }
  },
  toggleVisibility(state, layer) {
    switch (layer) {
      case 'railroads':
        state.visibility.railroads = !state.visibility.railroads;
        break;

      case 'oilpipelines':
        state.visibility.oilpipelines = !state.visibility.oilpipelines;
        break;

      case 'gaspipelines':
        state.visibility.gaspipelines = !state.visibility.gaspipelines;
        break;

      case 'ports':
        state.visibility.ports = !state.visibility.ports;
        break;

      default:
        break;
    }
  },
};

const actions = {
  zoomIn({ commit }) {
    commit('setZoom', 'in');
  },
  zoomOut({ commit }) {
    commit('setZoom', 'out');
  },
  updateVisibility({ commit }, layer) {
    commit('toggleVisibility', layer);
  },
};

const getters = {
  zoom: state => state.zoom,
  railroads: state => state.visibility.railroads,
  oilpipelines: state => state.visibility.oilpipelines,
  gaspipelines: state => state.visibility.gaspipelines,
  ports: state => state.visibility.ports,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
